import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import CMSPageListContent from "../layout/CMS/CMSPageListContent";
import Chatbox from "../layout/common/Chatbox";
import Footer from "../layout/common/Footer";
import Header from "../layout/common/Header";
import NavHeader from "../layout/common/NavHeader";
import SidebarTest from "../layout/common/SidebarTest";

const CMSPageList = () => {
  const [showChtBox, setShowChtBox] = useState(false);
  const [cmsListData, setCmsListData] = useState([]);

  const chtBoxHandler = (e) => {
    setShowChtBox(!e);
  };

  const chatboxClose = (e) => {
    setShowChtBox(!e);
  };

  const fetchCmsData = async () => {
    const data = await fetch(process.env.REACT_APP_API_URL +"cms-listing");
    const response = await data.json();
    setCmsListData(response);
  };

  useEffect(() => {
    fetchCmsData();
  }, []);

  return (
    <React.Fragment>
      <Helmet>
        <title>CMS Page</title>
      </Helmet>
      <NavHeader />
      <Header onClick={chtBoxHandler} showChtBox={showChtBox} />
      <Chatbox showChtBox={showChtBox} chatboxClose={chatboxClose} />
      <SidebarTest />
      <CMSPageListContent title="CMS Pages" cmsListData={cmsListData} />
      <Footer />
    </React.Fragment>
  );
};

export default CMSPageList;
